import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const CustomerEmojiBackground = t0 => {
  const $ = _c(15);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      id: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const id = t1 === undefined ? "CustomerEmojiBackground" : t1;
  const maskId = `${id}-mask`;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <circle cx="30" cy="30" r="30" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== maskId) {
    t3 = <mask id={maskId} fill="white">{t2}</mask>;
    $[4] = maskId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <circle fill="#F6F6F6" cx="30" cy="30" r="30" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `url(#${maskId})`;
  let t6;
  if ($[7] !== t5) {
    t6 = <polygon fillOpacity="0.05" fill="#000000" mask={t5} points="29.9915254 30 59.9830508 69.7004063 -1.83840766e-12 69.7004063" />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g><g>{t3}{t4}{t6}</g></g></g>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== props || $[13] !== t7) {
    t8 = <svg width="60px" height="60px" viewBox="0 0 60 60" {...props}>{t7}</svg>;
    $[12] = props;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
CustomerEmojiBackground.propTypes = {
  id: PropTypes.string
};
export default CustomerEmojiBackground;